import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { AppShell } from '@/components/shared/AppShell';
import { meOptions } from '@/features/auth/api';
import { ApiAccessPage } from '@/features/api-access/components/ApiAccessPage';

const apiAccessSearchSchema = z.object({
  // How the agent connects — REST skill bundle or MCP. In the URL so the MCP
  // setup can be linked directly.
  connect: z.enum(['skill', 'mcp']).optional(),
});

export const Route = createFileRoute('/_authed/settings/api-access')({
  validateSearch: apiAccessSearchSchema,
  loader: ({ context }) => context.queryClient.ensureQueryData(meOptions()),
  component: SettingsApiAccessPage,
});

function SettingsApiAccessPage() {
  const { data: me } = useSuspenseQuery(meOptions());
  const { connect } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <AppShell currentUser={{ id: me.id, displayName: me.display_name, email: me.email }}>
      <ApiAccessPage
        connectVia={connect ?? 'skill'}
        onConnectViaChange={(value) =>
          void navigate({
            search: (prev) => ({ ...prev, connect: value === 'skill' ? undefined : value }),
            replace: true,
          })
        }
      />
    </AppShell>
  );
}
